import Banner from "./Banner";
import Policy from "./Policy";

const PrivacyPolicy = ({ language }) => {
  return (
    <>
      <Banner language={language} />
      <Policy language={language} />
    </>
  );
};

export default PrivacyPolicy;